<template>
  <el-main class="rh-medtable">
    <h1>Pupilles</h1>
    <app-table
      tablenom="medpupilles"
      :cols="colonnes"
      :items="pupilles"
      :loadstatus="pupillesLoadStatus"
      :deletestatus="pupilleDeleteStatus"
      :formroutes="pupFormRoutes"
      :actions="pupActions"
      :ismeddetail="true"
    >
    </app-table>
  </el-main>
</template>
<script>
import AppTable from "@/components/rh/ui/table/AppTable";

export default {
  components: { "app-table": AppTable },
  data() {
    return {
      idMed: this.$route.params.idmed, // récupère le id du médecin dans l'url
      pupFormRoutes: {
        edit: {
          route: "med_pupilles_edit",
          params: { idmed: "id_tuteur", idtutorat: "id" },
        },
        create: {
          route: "med_pupilles_create",
          params: { idmed: this.$route.params.idmed },
        },
      },
    };
  },
  computed: {
    pupillesLoadStatus() {
      // 1 = loading, 2 = succès, 3 = échec du chargement des données
      return this.$store.state.tut.tuteursLoadStatus;
    },
    pupilleDeleteStatus() {
      // 1 = deleting, 2 = succès, 3 = échec
      return this.$store.state.tut.tuteurDeleteStatus;
    },
    pupilles() {
      // n'affiche que les pupilles du médecin sélectionné
      return this.$store.state.tut.tuteurs.filter(
        (t) => t.id_tuteur == this.idMed
      );
    },
    colonnes() {
      // n'affiche pas la colonne du nom du tuteur
      return this.$store.state.tut.colonnes.filter((c) => c.prop != "tuteur");
    },
    pupActions() {
      return this.$store.state.tut.actions;
    },
  },
};
</script>
